<ll-titulo>Categoría Typeform widget</ll-titulo>

<ll-toolnavbar>
    <typeform-widget-toolnavbar [displayButtons]="'all'"></typeform-widget-toolnavbar>
</ll-toolnavbar>

<typeform-widgets-new></typeform-widgets-new>
